import { NavigateFunction } from "react-router-dom";
import { CommunicationDataType, ContactInfoItemUi } from "./communication/communicationDataType";

export type RouteType = {
  path: string;
  element: any;
  hasBreadcrumb?: boolean;
  breadcrumbIndex?: number;
  defaultBackPath?: string;
  hasFooter?: boolean;
  hasFooterDownloadButtons?: boolean;
  breadcrumbTitles?: string[],
  backBaseRoute?: string,
  tqPageName?: string,
  companyName?: string
}

export const RealtimeBreadcrumbTitles = ['Raccolta Dati', 'Raccolta Foto', 'Cai']
export const ConfirmAuthBreadcrumbTitles = ['Cai', 'Cai', 'Cai']


export interface ApplicationState {
  communicationData: CommunicationDataType;
}

export interface DispatchWithCallbackType<T, K> {
  data?: T;
  events?: K;
  callback?: Function;
  navigate?: NavigateFunction;
  computeBareme?: boolean;
}

export interface ActionType {
  type: string;
  payload?: any;
}

export interface ValueLabelOption<T> {
  value: T;
  label: JSX.Element | string;
  subLabel?: string;
}

export const getValueLabelOptions = <T>(options: ValueLabelOption<T>[], val: T) => {
  return options.find(opt => opt.value === val)
}

export const createValueLabelOption = <T>(
  value: T,
  label: JSX.Element | string,
  subLabel?: string) => ({
    value,
    label,
    subLabel,
  })

export interface LabelArrayOption<T> {
  label: string;
  options: ValueLabelOption<T>[];
  type?: any;
  disabled?: boolean;
}

export interface SelectElementsType {
  all?: boolean;
  id?: number;
  value?: boolean;
}

export interface QueryStringState {
  readonly date: string;
  readonly timeframe: string;
  readonly id: String;
  readonly isUsr: Boolean;
}

export class MetadataType {
  public error: boolean = false;
  public errorCode: any = null;
  public isLoading: boolean = false;

  public resetPagination?: boolean = false;

  constructor(meta?: MetadataType) {
    if (meta) {
      this.error = meta.error;
      this.errorCode = meta.errorCode;
      this.isLoading = meta.isLoading;
      this.resetPagination = meta.resetPagination;
    }
  }
}

export type OnConfirmFunction<T> = (data: T) => void;


export interface ModalContentProps<T> {
  initValue?: any;
  initValues?: any;
  close?: any;
  onConfirmAndCloseHandler?: OnConfirmFunction<Partial<T>>;
  additionalData?: any;
  text?: any;
  additionalImage?: string
  buttonTxt?: string;
}

export interface ContactModalContentProps<T> extends ModalContentProps<T> {
  contactListPropItems: ContactInfoItemUi[];
  contactLabel?: string;
}

export class AddressType {
  public latitude: string = '';
  public longitude: string = '';
  public luogo: string = '';

  constructor(input?: any) {
    if (input) {
      this.latitude = input.latitude;
      this.longitude = input.longitude;
      this.luogo = input.luogo;
    }
  }
}

export enum BoolStringEnum {
  Y = 'Y',
  N = 'N',
  DN = 'DN'
}

export const booleanRadioOptions: ValueLabelOption<BoolStringEnum>[] = [{
  value: BoolStringEnum.Y,
  label: 'Sì'
}, {
  value: BoolStringEnum.N,
  label: 'No'
}]

export interface StateAction<T> {
  type: string;
  payload: T;
}

export const booleanWithDnRadioOptions: ValueLabelOption<BoolStringEnum>[] = [
  ...booleanRadioOptions
  , {
    value: BoolStringEnum.DN,
    label: 'Non so'
  }]
export interface InputItemType {
  propName: string;
  label?: string;
  isRequired?: boolean;
  elClassName?: string;
}

export interface CommonInfoCmpProps<T> {
  questionLabel?: string;
  initValues: T;
  onChange?: (updValues: Partial<T>) => void
}

export interface OtherContactCaiInfoCmpProps<T> extends CommonInfoCmpProps<T> {
  contactListPropItems: ContactInfoItemUi[];
  contactLabel?: string;
}

export const messageRequired = "Questo campo è obbligatorio";
export const emailFormatMessage = "Sicuro? L’indirizzo email inserito non è corretto.";
export const numberFormat = 'Il numero inserito non è corretto. Inserisci solo caratteri numerici (es: 1; 5; 7..)';
export const numberFormatLength = 'Il numero inserito è troppo corto.';

export enum TemplateTypeEnum {
  SIN_INAT = 'SIN_INAT',
  CASE_1B_APP = 'CASE_1B_APP',
  CONFIRM_AND_AUTHORIZE_USER = 'CONFIRM_AND_AUTHORIZE_USER',
  REALTIME_ACCETTAZIONE_CAI = 'REALTIME_ACCETTAZIONE_CAI'
}
export const UNIPOLSAI_COMPLETE = "UNIPOL"
export const UNIPOLSAI_COMPLETE_CODE = "0034"
export const UNIPOLSAI_SUBSTRING = 'UNIPOL'

export enum TemplateLinearTypeEnum {
  LINEAR_CAI_WEBAPP = 'LINEAR_CAI_WEBAPP',
  CONFIRM_AND_AUTHORIZE_USER = 'CONFIRM_AND_AUTHORIZE_USER',
  LINEAR_REALTIME_ACCETTAZIONE_CAI = 'LINEAR_REALTIME_ACCETTAZIONE_CAI'
}

export enum LinearFileTypeEnum {
  CAI_DOC = 'CAI-DOC',
  CAI_REPORT = 'CAI-REPORT',
  SIGNED_COMPLAINT = 'SIGNED-COMPLAINT',
  DRIVER_LICENSE = 'DRIVER-LICENSE',
  DRIVER_LICENSE_FRONT = 'DRIVER-LICENSE-FRONT',
  DRIVER_LICENSE_REAR = 'DRIVER-LICENSE-REAR',

  CONFIRM_IDENTITY = 'CONFIRM-IDENTITY',

  INSURED_LICENSE = 'INSURED-LICENSE',
  INSURED_LICENSE_FRONT = 'INSURED-LICENSE-FRONT',
  INSURED_LICENSE_REAR = 'INSURED-LICENSE-REAR',
  WITNESSES_STATEMENT = 'WITNESSES-STATEMENT',
  ID_WITNESSES = 'ID-WITNESSES',
  ID_WITNESSES_FRONT = 'ID-WITNESSES-FRONT',
  ID_WITNESSES_REAR = 'ID-WITNESSES-REAR',
  OTHER_DOCUMENTS = 'OTHER-DOCUMENTS',
}

export enum FileSideEnum {
  FRONT = 'front',
  RETRO = 'retro'
}

export enum TrctProposePhotosQuestionEnum {
  TAKE_ADDITIONAL_PHOTOS = 'TAKE_ADDITIONAL_PHOTOS',
  SKIP_PHOTOS_FLOW = 'SKIP_PHOTOS_FLOW',
}

export enum PhotoTypeEnum {
  ANGOLARE_VEICOLO_DOCS = "ANGOLARE-VEICOLO-DOCS",
  CARTA_CIRCOLAZIONE_DOCS = "CARTA-CIRCOLAZIONE-DOCS",
  CRUSCOTTO_DOCS = "CRUSCOTTO-DOCS",
  PATENTE_DOCS = "PATENTE-DOCS",
  CAI_PAPER_DOCS = "CAI-PAPER-DOCS",
  DANNO_VEICOLO_DOCS = "DANNO-VEICOLO-DOCS",
  DANNO_VEICOLO_CTP_DOCS = "DANNO-VEICOLO-CTP-DOCS",
  OTHER_USEFUL_INFO_DOCS = "OTHER-USEFUL-INFO-DOCS",
}

export const LiqPhotoTypeMapper: { [key in PhotoTypeEnum]: string } = {
  [PhotoTypeEnum.DANNO_VEICOLO_DOCS]: "foto",
  [PhotoTypeEnum.DANNO_VEICOLO_CTP_DOCS]: "foto",
  [PhotoTypeEnum.ANGOLARE_VEICOLO_DOCS]: "foto",
  [PhotoTypeEnum.CRUSCOTTO_DOCS]: "foto",
  [PhotoTypeEnum.CARTA_CIRCOLAZIONE_DOCS]: "librettocircolazione",
  [PhotoTypeEnum.PATENTE_DOCS]: "patente",
  [PhotoTypeEnum.OTHER_USEFUL_INFO_DOCS]: "altro",
  [PhotoTypeEnum.CAI_PAPER_DOCS]: "cai",
}